import {
  Box,
  Flex,
  Image,
  Text,
  SimpleGrid,
  GridItem,
  Heading,
  HStack,
  Icon,
} from "@chakra-ui/react";
import { CiCirclePlus } from "react-icons/ci";
import { FaLinkedin, FaFacebook } from "react-icons/fa";

import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Partners } from "../components/Partners";

import GroupImage4 from "../assets/images/groupImage4.png";
import GroupImage5 from "../assets/images/groupImage5.png";
import Partner1 from "../assets/images/partner1.png";
import Partner2 from "../assets/images/partner2.png";
import Partner3 from "../assets/images/partner3.png";

const visionsAndMissions = [
  {
    id: 1,
    title: "Vision",
    description:
      "To catalyze change by systematically bridging research and social impact investments across diverse sectors.",
    features: [
      "Bridging research & impact",
      "Strategic investment",
      "Driving meaningful change",
    ],
  },
  {
    id: 2,
    title: "Mission",
    description:
      "We unite academic insights, corporate social responsibility, and community needs to empower local organizations, drive sustainable projects, and create lasting social impact.",
    features: [
      "Integrating knowledge and actions",
      "Empowering local organizations",
      "Creating lasting impact",
    ],
  },
];

const teamMembers = [
  {
    id: 1,
    name: "Maya Caldwell",
    description: "Leads strategy, operations, and mission alignment",
    image: Partner1,
    role: "EXECUTIVE DIRECTOR/CEO",
  },
  {
    id: 2,
    name: "Ava Williams",
    description: "Manages finances, funding, and legal compliance",
    image: Partner2,
    role: "EXEFINANCE & COMPLIANCE OFFICER",
  },
  {
    id: 3,
    name: "Jordan Patel",
    description: "Builds collaborations to drive social change",
    image: Partner3,
    role: "IMPACT & PARTNERSHIP MANAGER",
  },
];

export const Story = () => {
  return (
    <Box>
      <Header dark={false} />

      <Box bg="white" borderTopWidth={"1px"} borderColor={"#E8E9EA"}>
        <Flex
          pt={{ base: "64px", md: "87px" }}
          align={"center"}
          justify={"center"}
          flexDir={"column"}
        >
          <Flex
            align={"center"}
            justify={"center"}
            borderWidth={"1px"}
            borderColor={"#8AA7A5"}
            borderRadius={"30px"}
            backgroundColor={"rgba(235, 240, 240, 0.5)"}
            py={"11px"}
            px="20px"
            mb="12px"
          >
            <Text
              fontSize={"13px"}
              fontWeight={500}
              color={"#346864"}
              fontFamily={"Sora-Regular"}
            >
              ABOUT
            </Text>
          </Flex>

          <Heading
            fontSize={{ base: "28px", md: "48px" }}
            fontWeight={500}
            color={"#101828"}
            fontFamily={"DMSans-Medium"}
          >
            Our Vision & Mission
          </Heading>
        </Flex>
      </Box>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        mt={{ base: "35px", md: "87px" }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <GridItem display={{ base: "none", md: "block" }}>
          <Image src={GroupImage4} objectFit={"cover"} w={"100%"} h="100%" />
        </GridItem>

        <GridItem
          bg="#F4F8F8"
          py="55px"
          pl={{ base: "16px", md: "70px" }}
          pr={{ base: "16px", md: "70px" }}
        >
          <Flex
            gap={"40px"}
            flexDir={"column"}
            justify={"center"}
            alignSelf={"center"}
            h={"100%"}
          >
            {visionsAndMissions.map((item) => (
              <Flex
                flexDir={"column"}
                justify={"space-around"}
                gap={"40px"}
                key={item.id}
              >
                <Box
                  borderRadius={"10px"}
                  bg="white"
                  borderWidth={"1px"}
                  borderColor={"#ECECEC"}
                  p={{ base: "24px", md: "40px" }}
                >
                  <Heading
                    fontSize={"23px"}
                    color={"#101720"}
                    fontFamily={"DMSans-Medium"}
                  >
                    {item.title}
                  </Heading>

                  <Text
                    fontSize={{ base: "13px", md: "16px" }}
                    color={"#667085"}
                    mt="8px"
                    mb="17px"
                    fontFamily={"Sora-Regular"}
                  >
                    {item.description}
                  </Text>

                  {item.features.map((feature) => (
                    <Flex gap={"8px"} align={"center"} my="8px">
                      <Icon size={"md"} color={"#667085"}>
                        <CiCirclePlus />
                      </Icon>

                      <Text
                        fontSize={{ base: "13px", md: "16px" }}
                        color={"#667085"}
                        fontFamily={"Sora-Regular"}
                      >
                        {feature}
                      </Text>
                    </Flex>
                  ))}
                </Box>
              </Flex>
            ))}
          </Flex>
        </GridItem>
      </SimpleGrid>

      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <GridItem>
          <Flex
            flexDir={"column"}
            bg="#122625"
            pr={{ base: "16px", md: "74px" }}
            pl={{ base: "16px", md: "74px" }}
            py={{ base: "64px" }}
            justify={"center"}
            h={"100%"}
          >
            <Heading
              fontSize={{ base: "28px", md: "48px" }}
              fontWeight={500}
              color={"white"}
              lineHeight={"140%"}
              mb="8px"
              fontFamily={"DMSans-Medium"}
            >
              Our Story
            </Heading>

            <Text
              fontSize={{ base: "16px", md: "19px" }}
              color={"#EBF0F0"}
              lineHeight={"200%"}
              fontFamily={"Sora-Regular"}
            >
              Founded on the belief that research must translate into action,
              our LLC was born to systematically connect the dots between
              cutting-edge academic research, corporate social responsibility
              initiatives, and grassroots community efforts. Our structured
              approach—from identifying key research areas to scaling successful
              projects—ensures that every investment not only drives social
              change but also builds a more sustainable future
            </Text>
          </Flex>
        </GridItem>

        <GridItem>
          <Image src={GroupImage5} objectFit={"cover"} h={"100%"} />
        </GridItem>
      </SimpleGrid>

      <Box
        bg="white"
        py={{ base: "64px", md: "92px" }}
        px={{ base: "16px", md: "70px" }}
        maxW={{ base: "100%", "2xl": "1300px" }}
        mx="auto"
      >
        <Flex
          gap={{ base: "24px", md: "194px" }}
          justify={"space-between"}
          flexDir={{ base: "column", md: "row" }}
        >
          <Text
            fontSize={{ base: "16px", md: "19px" }}
            color={"black"}
            textDecoration={"underline"}
            whiteSpace={"nowrap"}
            fontFamily={"Sora-Regular"}
          >
            TEAM
          </Text>

          <Heading
            fontSize={{ base: "28px", md: "48px" }}
            color={"#203F3D"}
            lineHeight={"140%"}
            fontWeight={500}
            fontFamily={"DMSans-Medium"}
          >
            Meet our Team & Partners
          </Heading>

          <Text
            fontSize={{ base: "16px", md: "19px" }}
            color={"#667085"}
            w={{ base: "100%", md: "67%" }}
            fontFamily={"Sora-Regular"}
          >
            Meet our dedicated team of experts and strategic partners from
            universities, multinational corporations, and community-based
            organizations. Together, we harness the power of collaboration to
            create transformative impact
          </Text>
        </Flex>

        <SimpleGrid
          mt={{ base: "32px", md: "70px" }}
          columns={{ base: 1, md: 3 }}
          gap={{ base: "32px", md: "42px" }}
        >
          {teamMembers.map((member) => (
            <GridItem key={member.id}>
              <Image src={member.image} objectFit={"cover"} w="100%" />

              <Box mt={{ base: "11px", md: "24px" }}>
                <Heading
                  fontSize={{ base: "11px", md: "13px" }}
                  fontWeight={500}
                  color={"#101828"}
                  fontFamily={"Sora-Regular"}
                >
                  {member.role}
                </Heading>

                <Heading
                  fontSize={{ base: "23px", md: "29px" }}
                  fontWeight={500}
                  color={"#203F3D"}
                  fontFamily={"DMSans-Medium"}
                >
                  {member.name}
                </Heading>

                <Text
                  fontSize={{ base: "14px", md: "16px" }}
                  color={"#667085"}
                  mt={{ base: "8px", md: "16px" }}
                  mb={{ base: "16px", md: "24px" }}
                  fontFamily={"Sora-Regular"}
                >
                  {member.description}
                </Text>

                <HStack gap={"20px"}>
                  <Icon size={"md"} color={"#98A2B3"}>
                    <FaLinkedin />
                  </Icon>

                  <Icon size={"md"} color={"#98A2B3"}>
                    <FaFacebook />
                  </Icon>
                </HStack>
              </Box>
            </GridItem>
          ))}
        </SimpleGrid>
      </Box>

      <Partners />

      <Footer />
    </Box>
  );
};
